import { renderUI } from './UI';
const rootElement = document.getElementById('root') as HTMLElement;

renderUI(rootElement);
